import { createAction, createSlice } from '@reduxjs/toolkit';
import type { SessionExpiredProperties } from 'analytics/types';

import { User } from '../types/user';
import { Action } from './base';

const initialState: User = {
  id: 0,
  email: '',
  accessToken: '',
  isAdmin: false,
  projectId: 0,
  subProjectId: 0,
  subProjectIds: '',
  role: null,
  countryCode: '',
  permissions: [],
  permissionsHash: '',
  firebaseToken: null,
  firebaseUid: null,
};

interface UserAction extends Action {
  payload: User;
}

interface SetPermissionsAction extends Action {
  payload: { permissions: string[]; hash: string };
}

interface SetFirebaseUidAction extends Action {
  payload: string | null;
}

interface UpdateAccessTokenAction extends Action {
  payload: string;
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signInUser(state: User, action: UserAction) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
    signUpUser(state: User, action: UserAction) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
    signOutUser() {
      return {
        ...initialState,
      };
    },
    setPermissions(state: User, action: SetPermissionsAction) {
      return {
        ...state,
        permissions: action.payload.permissions,
        permissionsHash: action.payload.hash,
      };
    },
    setFirebaseUid(state: User, action: SetFirebaseUidAction) {
      return {
        ...state,
        firebaseUid: action.payload,
      };
    },
    updateAccessToken(state: User, action: UpdateAccessTokenAction) {
      return {
        ...state,
        accessToken: action.payload,
      };
    },
  },
});

export const { signInUser, signUpUser, signOutUser, setPermissions, setFirebaseUid, updateAccessToken } =
  userSlice.actions;
/** Dispatched right before a forced sign-out, while the user is still in the store, so analytics can record why. */
export const sessionExpired = createAction<SessionExpiredProperties['reason']>('user/sessionExpired');
export default userSlice.reducer;
